import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { CounsellingDashboardService } from '../counselling-dashboard.service';
import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';
import {  NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-counselling-dashboard',
  templateUrl: './counselling-dashboard.component.html',
  styleUrls: ['./counselling-dashboard.component.scss']
})
export class CounsellingDashboardComponent {
  data: any;
  show:number=1
  reports:any
  shows:boolean=false
  data1: any;
  attendanes: any;
  admno: any;

  constructor( private student: CounsellingDashboardService,private http: HttpClient, private loader : NgxSpinnerService){  }

  ngOnInit(): void {
      // this.loader.show()
    this.getdata() 
    // this.loader.hide()
  }

getdata(){
  this.loader.show();
  this.student.getstudent().subscribe((res: any) => {
    
    this.data = res;
    
    $(document).ready(() => {
      $('#example1').DataTable( {
        scrollX: true 
      }); 
   
    });
    this.loader.hide();
  });
 
}

page(report:any){
  this.loader.show();
  this.data1=report.campusId
  this.student.getdashboard(this.data1).subscribe((res: any) => {
    this.attendanes = res;
    $(document).ready(() => {
      $('#example').DataTable({
        scrollX: true 
      }); 
    });
 
  })
  this.show=2
  this.loader.hide();
}
pages(report:any){
  this.loader.show();
this.reports=report.admNo
console.log("hai",report);

this.show=3
this.loader.hide()
}
backClicked() {
  $(document).ready(() => {
    $('#example1').DataTable( {
      scrollX: true 
    }); 
  });
  this.show=1 
}
counselling(e:any){
  this.loader.show()
  $(document).ready(() => {
    $('#example').DataTable( {
      scrollX: true 
    }); 
  });
  this.show=e.page;
  console.log('e',e);
   this.loader.hide()
}
pdf(report:any){
  this.loader.show()
  this.admno=report.admNo
this.student.generatepdf(this.admno).subscribe((res: any) => {
    var newBlob = new Blob([res], { type: "application/pdf" });
    const data = window.URL.createObjectURL(newBlob);
    var link = document.createElement("a");
    link.href = data;
    link.download = this.admno +"student counselling";
    this.loader.hide()
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );
 
    setTimeout(function() {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
    }, 100);
  },

  (  err: any) => {
    console.log("ERR", err);
  }
);
}
exportExcel(){
   const excelData = this.data.counsellingReport.map((report: any) => ({
      State: report.stateName,
      City: report.cityName,
      Campus: report.campusName,
      'Total Counselling': report.totalCounselling
    }));

    // Convert JSON → Worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const workbook: XLSX.WorkBook = { Sheets: { 'Counselling Report': worksheet }, SheetNames: ['Counselling Report'] };

    // Generate buffer
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Save file
    const file: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    alert('Excel will be downloaded. Check your Downloads folder.');
    saveAs(file, 'Counselling_Report.xlsx');
  }

    exportCampuswiseExcel() {
    const excelData = this.attendanes.campuswiseCounsellingReport.map((report: any) => ({
      AdmissionNo: report.admNo,
      Student: report.studentName,
      Class: report.className,
      'Course Track': report.courseTrackName,
      'Exam Program': report.examProgramName,
      Section: report.sectionName,
      'Counsel Date': report.counselDate,
      Counsellor: report.userName,
    Stage:
  report.totalCounsel == 1 || report.totalCounsel == '1'
    ? 'Counselling'
    : report.totalCounsel == 2 || report.totalCounsel == '2'
    ? '1st FollowUp'
    : report.totalCounsel == 3 || report.totalCounsel == '3'
    ? '2nd FollowUp'
    : ''
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const workbook: XLSX.WorkBook = { Sheets: { 'Campuswise Report': worksheet }, SheetNames: ['Campuswise Report'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const file: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    alert('Excel will be downloaded. Check your Downloads folder.');
    saveAs(file, 'CampuswiseCounselling_Report.xlsx');
  }
}





